export const PREFERENCES_PAGE = "We've updated how often you'll receive Pocket Hits.";
export const UNSUBSCRIBE_PAGE_PRIMARY = "Alrighty, we’ve removed your email address from our list.";
export const UNSUBSCRIBE_PAGE_SECONDARY = "Having second thoughts? Try getting our emails less often instead.";

export const PAGE_ACTION_UNSUBSCRIBE = 'unsubscribe';
export const PAGE_ACTION_PREFERENCES = 'preferences';

export const RADIO_GROUP_NAME = 'frequency';
export const STATUS_SUBSCRIBED = 'subscribed';
export const STATUS_UNSUBSCRIBED = 'unsubscribed';
